import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import * as S from "./ActivityContent/ActivityContent.styled";
import { ContentMeta } from "./ContentMeta";
export var ChatContent = function (_a) {
    var _b;
    var chatMessageId = _a.chatMessageId, message = _a.message;
    return (_jsxs(S.Wrapper, { children: [_jsx(ContentMeta, { meta: (_b = {},
                    _b[getLocalizedText("activity.content.chat.chat_id")] = chatMessageId,
                    _b) }), _jsx(S.ContentTitle, { children: getLocalizedText("activity.content.chat.message") }), _jsx(S.MessageWrapper, { children: message })] }));
};
